import { fromJSON } from "@suse-o11y/from-json";
import { toJSON } from "@suse-o11y/to-json";
import { type QueryParamConfig, decodeString, encodeString } from "serialize-query-params";

import { type Spec, decoder, encoder } from "./_spec";

const QueryParam = {
	encode(value) {
		const encoded = value == null ? null : encoder(value).encode();

		if (encoded == null) {
			return undefined;
		}

		return encodeString(toJSON(encoded)) ?? undefined;
	},

	decode(raw) {
		const [, value] = fromJSON(decodeString(raw) ?? "", decoder);

		return value ?? undefined;
	},
} satisfies QueryParamConfig<undefined | Spec>;

export { QueryParam };
